import BasicInput from '../../shared/input';
var TextInput = BasicInput;
export default TextInput;